<template>
    <footer>
        <div class="x-header-wrapper">
                <div class="copyright">
                    <p>版权</p>
                    <p>xiaojiu© 2017 - 2019</p>
                </div>
        </div>
    </footer>
</template>


<script>
    export default {

    }
</script>

<style scoped>
.x-header-wrapper{width: 100%; height: 200px; left: 0;  right: 0;  height: 180px;}
.copyright{max-width: 1260px; margin: 0 auto; height: 180px; text-align: center; }
/*.copyright>p{position: absolute; left: 0;}*/
</style>


// WEBPACK FOOTER //
// src/components/footer/footer.vue